import React from 'react';
import './DataNote.scss';

import {  activateAdminNoteView, addSelectedPartNote, openDeleteInputFormsForNotePart} from '../../../adminSlice';
import Config from '../../../../../config/config';
import { divideText } from '../../../../../helper/dividerForTextNote';


const DataNote = (props) => {
       
    const {dispatch} = props;
    const serverPath = Config.serverPath;






//DELETE PART OF NOTE
const handlerClickDeletePartNote = (e) => {
    const notePart = e.target.value;
    // console.log(notePart);
    dispatch(addSelectedPartNote(notePart));
      
    dispatch(openDeleteInputFormsForNotePart());
}



    //ACTIVATE NOTE VIEW + ADD PART NOTE

const handlerClickAddPartNote = (e) => {
    const previousPart = Number(e.target.value);
    //console.log(typeof(previousPart));
   // setPartNote(previousPart + 1);
    dispatch(addSelectedPartNote(previousPart+1));
    dispatch(activateAdminNoteView());
    props.onClearInputForms();
}


//DELETE IMG OF NOTE-no use
/*
const handlerClickDeleteImgNote = (e) => {
    const imgPath = e.target.value;
    // console.log(imgPath);
       dispatch(addDeletedImgPathPartNote(imgPath));
      
       dispatch(openDeleteInputFormsForImageNotePart());
}
*/

//FIND NOTE
const dataNotes = props.dataNotes;
const selectedIdNote = props.selectedIdNote;
//const selectedIdNote = 41;
//console.log(dataNotes);

//!!! CALCULATE  EVERY TIME WHEN NOTE PART RENDER
const findNote = (selectedId, data ) => {
    const result = data.find(({id}) => id===selectedId);
    return result;
}
const result = findNote(selectedIdNote, dataNotes);
//console.log(result);
//const resultNote = dataNotes.find(({id}) => id===selectedIdNote);
//console.log(resultNote);

//EDIT PART NOTE
const handlerClickEditPartNote = (e) => {
    const result = findNote(selectedIdNote, dataNotes);
   
    const index= e.target.value;
    console.log(result);
    console.log(props.dataNotes);

    const selectItem = {
        notePartText: result.content[index].text, 
        noteImgText: result.content[index].img_text,
        notePartTitle: result.content[index].note_parttitle,
        //notePartText: 'ntrcn', 
        //noteImgText: 'dfgsgsg',            
         
    }
    const notePart = result.content[index].part
    dispatch(addSelectedPartNote(notePart));

    console.log(selectItem);

    props.onChangePartNote(selectItem);
  

}





//RENDER NOTE PARTS

const renderNoteParts = (data) => {
    //console.log("Start render NotePart")
    //console.log(data);

    return (
        data.map((item, index) => {
            //console.log(index);
           // console.log(item.part);
            const noteName = item.img_path;
            const note_src = noteName? `${serverPath}/api/notes/${selectedIdNote}/${item.img_path}`: null;  
           // console.log(note_src);
           //IF NOTE IMG EXISTS
            if (note_src) {
                return (
                    <div className='main-container' key={item.part}>

                    
                    <div className='notepart-container' >
                        
                        <div className='note-part-content'>
                        {/*<p className='part'>Часть {item.part}</p>*/}
                            <div className='img-main-container'>

                            
                                <div className='img-container'>
                                    <img alt="note" src={note_src} />
                                </div>
                                <div className='img-text-container'>
                                    <p className='text-image'>{item.img_text}</p>
                                </div>
                               
                            </div>
                            <div className='text-container'>
                            <p className='part-title'>{item.note_parttitle}</p>
                                    {divideText(item.text)}
                            </div>
                            
                        </div>

                        <div className='edit-container'>
                            <p className='part'>{props.selectedIdNote}.{item.part}</p>
                            <button value={index}  className='edit-button' onClick ={handlerClickEditPartNote}></button>
                            {/* <button value={item.img_path} onClick={handlerClickDeleteImgNote} className='delete-img-button'></button>} */}
                            <button value={item.part}className='delete-note-button' onClick={handlerClickDeletePartNote} ></button>
                        </div>
                        
                    </div>
                        <button value={item.part} onClick={handlerClickAddPartNote} className='add-part-button'>Добавить</button>
                        
                    </div>
                )

            } else {
                return (
                    <div className='main-container' key={item.part}>

                        <div className='notepart-container' >
                            
                            <div className='note-part-content'>
                           
                                <div className='text-container'>
                                <p className='part-title'>{item.note_parttitle}</p>
                                {divideText(item.text)}
                                </div>
                            </div> 
                            <div className='edit-container'>
                                <p className='part'>{props.selectedIdNote}.{item.part}</p>
                                <button value={index}  className='edit-button' onClick ={handlerClickEditPartNote}></button>
                                
                                <button value={item.part} onClick={handlerClickDeletePartNote} className='delete-note-button'></button>
                            </div>   
                        </div>
                        <button value={item.part} onClick={handlerClickAddPartNote} className='add-part-button'>Добавить</button>
                    </div>
                )                
            }
        
          })

    )
  
}


    return (
        <div className='DataNote'>
            <h5>{props.selectedIdNote}. {props.selectedIdNoteText}</h5>
            <button onClick={handlerClickAddPartNote} className='add-part-button'>Добавить</button>
            {result ? renderNoteParts(result.content): null}
        </div>
    )
}
export default DataNote;